import axios from "axios";
import authService from "../routes/authService";
import {
  resolveApiBaseUrl,
  shouldRedirectToLoginOn401,
  shouldAttachBearerToken,
  shouldRemoveJsonContentType,
} from "./axiosAuthUtils";

const envApiUrl = process.env.REACT_APP_API_URL;
export const API_BASE_URL = resolveApiBaseUrl(envApiUrl);

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = authService.getToken();
    if (shouldAttachBearerToken(token)) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    if (shouldRemoveJsonContentType(config.data)) {
      delete config.headers["Content-Type"];
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    const requestUrl = String(originalRequest?.url || "");

    if (
      shouldRedirectToLoginOn401({
        status: error.response?.status,
        requestUrl,
        pathname: window.location.pathname,
        retried: originalRequest._retry,
      })
    ) {
      originalRequest._retry = true;
      console.error(
        "Sessão expirada. Redirecionando para login..."
      );
      authService.logout();
      window.location.href = "/login";
      return Promise.reject(error);
    }

    if (error.response?.status === 403) {
      console.error(
        "Acesso negado:",
        originalRequest?.method,
        originalRequest?.url,
        error.response?.data
      );
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
